// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__7U30b","list":"PatternAutocomplete_list__3FvVy"};